import { useMemo } from 'react';
import Currency from '../../../components/currency/Currency';
import { NatureEnum } from '../../../types/nature';
import { WorksheetEntryV2 } from '../../../types/worksheet';

type EntriesSubtotalProps = {
    entries: WorksheetEntryV2[];
};

function EntriesSubtotal({ entries }: EntriesSubtotalProps): JSX.Element {
    const subtotal = useMemo(() => calculateSubtotal(entries), [entries]);

    return (
        <div className="text-right mt-4">
            <p className="text-gray-500 text-xs font-bold">Subtotal</p>
            <Currency className=" text-gray-800" value={Math.abs(subtotal)} withParentheses={subtotal < 0} />
        </div>
    );
}

function calculateSubtotal(entries: WorksheetEntryV2[] = []): number {
    const subtotal = entries.reduce((acc, entry) => {
        return acc + (entry.nature === NatureEnum.CREDIT ? (entry.amount || 0) * -1 : entry.amount || 0);
    }, 0);
    return subtotal;
}

export default EntriesSubtotal;
